/* eslint-disable no-new */
// DES加密
import CryptoJS from "crypto-js";
import lang_ from "./locales.js";
import Vue from "vue";
import { getBrandByAlias, getCountry } from "./api";
import { Toast } from "vant";

var myfn = {
  encryptByDES(message, key) {
    key = "gingerso";
    const keyHex = CryptoJS.enc.Utf8.parse(key);
    const encrypted = CryptoJS.DES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  },
  stringToByte(str) {
    var bytes = new Array();
    var len, c;
    len = str.length;
    for (var i = 0; i < len; i++) {
      c = str.charCodeAt(i);
      if (c >= 0x010000 && c <= 0x10ffff) {
        bytes.push(((c >> 18) & 0x07) | 0xf0);
        bytes.push(((c >> 12) & 0x3f) | 0x80);
        bytes.push(((c >> 6) & 0x3f) | 0x80);
        bytes.push((c & 0x3f) | 0x80);
      } else if (c >= 0x000800 && c <= 0x00ffff) {
        bytes.push(((c >> 12) & 0x0f) | 0xe0);
        bytes.push(((c >> 6) & 0x3f) | 0x80);
        bytes.push((c & 0x3f) | 0x80);
      } else if (c >= 0x000080 && c <= 0x0007ff) {
        bytes.push(((c >> 6) & 0x1f) | 0xc0);
        bytes.push((c & 0x3f) | 0x80);
      } else {
        bytes.push(c & 0xff);
      }
    }
    return bytes;
  },
  GetQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return "";
  },
  // 隨機數
  randomWord(randomFlag, min, max) {
    var str = "",
      range = min,
      arr = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ];

    if (randomFlag) {
      range = Math.round(Math.random() * (max - min)) + min;
    }
    for (var i = 0; i < range; i++) {
      var pos = Math.round(Math.random() * (arr.length - 1));
      str += arr[pos];
    }
    return str;
  },
  /**
   * 根據 vw 或 vh  獲取 px
   * @param {Object} type 類型 vm / vh
   * @param {Object} val  值
   */
  GETPXBYVW_VH(type, val) {
    if (type == "vw") {
      return val / (100 / window.innerWidth);
    } else if (type == "vh") {
      return val / (100 / window.innerHeight);
    }
    return 0;
  },
  /**
   * 根據 px  獲取 vw 或 vh
   * @param {Object} type 類型 vm / vh
   * @param {Object} val 值
   */
  GETVW_VHBYPX(type, val) {
    if (type == "vw") {
      return (100 / window.innerWidth) * val;
    } else if (type == "vh") {
      return (100 / window.innerHeight) * val;
    }
    return 0;
  },
  /**
   * 校驗圖片是否可用
   * @param {Object} img
   */
  errorImg(img) {
    if (img == undefined || img == "" || img == null) {
      return false;
    }
    var ImgObj = new Image();
    ImgObj.src = img;
    if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
      return true;
    } else {
      return false;
    }
  },
  // 判斷 是否為空
  ISNULL(obj) {
    return obj == undefined || obj == null || obj == "";
  },
  // 設置用戶信息
  userInfo: {
    // 獲取
    get(e) {
      return localStorage.getItem(`userinfo_${myfn.getBrandId(e, 1)}`);
    },
    // 設置
    set(e, obj) {
      localStorage.setItem(
        `userinfo_${myfn.getBrandId(e, 1)}`,
        JSON.stringify(obj)
      );
    },
    // 清理
    clear(e) {
      localStorage.removeItem(`userinfo_${myfn.getBrandId(e, 1)}`);
    }
  },
  /**
   * 獲取 brandId
   */
  getBrandId(e, t) {
    // 品牌ID
    if (t != 1) {
      let userinfo = myfn.userInfo.get(e);
      if (this.ISNULL(userinfo)) {
        e.$toast({
          duration: 2000,
          // icon: 'cross',
          message: lang_.t("Identity expired"),
          onClose: () => {
            e.$router.replace({
              name: "vipCard",
              params: {
                arg: myfn.setQueryParams(myfn.getBrandId(e, 1))
              }
            });
          }
        });
        return;
      }
    }
    let params = e.$route.params;
    return this.getBrandStaticId(params);
  },
  getBrandStaticId(params) {
    let brandId = "";
    let href = location.href;
    // gs 品牌
    if (href.indexOf("gingersoft-alias") > -1) {
      brandId = 1;
    }
    //
    else if (href.indexOf("california-pizza-kitchen") > -1) {
      brandId = 275;
    }
    // 屏山老地方 2021-9-2 加入
    else if (location.href.indexOf("PSLDF") > -1) {
      brandId = 357;
    } else if (location.href.indexOf("JNMS") > -1) {
      brandId = 397;
    }
    // 2021-9-11 加入,  點心到
    else if (location.href.indexOf("DXD") > -1) {
      brandId = 395;
    } else if (location.href.indexOf("YLRZLM") > -1) {
      brandId = 384;
    } else if (location.href.indexOf("XYZlAM") > -1) {
      brandId = 356;
    } else if (location.href.indexOf("QWERTY") > -1) {
      brandId = 409;
    } else if (location.href.indexOf("PEJSHF") > -1) {
      brandId = 558;
    } else if (location.href.indexOf("JUYDNH") > -1) {
      brandId = 520;
    } else if (location.href.indexOf("FBAQWE") > -1) {
      brandId = 618;
    } else if (location.href.indexOf("BeppuLMDJ") > -1) {
      brandId = 636;
    } else if (location.href.indexOf("LEZHOUBEN") > -1) {
      brandId = 423;
    } else if (location.href.indexOf("MUNIUBINSI") > -1) {
      brandId = 347;
    } else if (location.href.indexOf("HAIJIYUDAN") > -1) {
      brandId = 499;
    } else if (location.href.indexOf("XINMANGU") > -1) {
      brandId = 338;
    } else if (location.href.indexOf("SUANLAXIAN") > -1) {
      brandId = 353;
    } else if (location.href.indexOf("SHITINGJU") > -1) {
      brandId = 340;
    } else if (location.href.indexOf("HEINEIDANIAN") > -1) {
      brandId = 346;
    } else if (location.href.indexOf("ZIJIALIAOLI") > -1) {
      brandId = 345;
    } else if (location.href.indexOf("DIYIJUN") > -1) {
      brandId = 400;
    } else if (location.href.indexOf("SBWTZSFNRM") > -1) {
      brandId = 386;
    } else if (location.href.indexOf("LSFZYXGS") > -1) {
      brandId = 641;
    } else if (location.href.indexOf("WINECITY") > -1) {
      brandId = 642;
    } else {
      let encParams = myfn.getQueryParams(params);
      brandId = encParams[0];
    }
    return brandId;
  },
  getDate(date) {
    var d = new Date(date);
    if (date == null) {
      d = new Date();
    }
    var m = d.getMonth() + 1;
    if (m < 10) {
      m = "0" + m;
    }
    var day = d.getDate();
    if (day < 10) {
      day = "0" + day;
    }
    return d.getFullYear() + "-" + m + "-" + day;
  },
  getDate2(date) {
    if (typeof date == "string") {
      date = date.replace(/-/g, "/");
      date = date.replace(".0", "");
    }
    var d = new Date(date);
    if (date == null) d = new Date();

    var m = d.getMonth() + 1;
    if (m < 10) m = "0" + m;

    var day = d.getDate();
    if (day < 10) day = "0" + day;

    let h = d.getHours();
    if (h < 10) h = `0${h}`;

    let min = d.getMinutes();
    if (min < 10) min = `0${min}`;

    let s = d.getSeconds();
    if (s < 10) s = `0${s}`;
    let t = `${d.getFullYear()}-${m}-${day} ${h}:${min}:${s}`;
    if (t.indexOf("NaN") > -1 || t.indexOf("null") > -1) {
      t = "";
    }
    return t;
  },
  // 監測是否是數字並處理
  numberRegex(obj) {
    return obj.replace(/\D/g, "");
  },
  /**
   * 判斷是否是email
   * @param {Object} email
   */
  ISEMAIL(email) {
    var pattern = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/g;
    return pattern.test(email);
  },
  /**
   * 修改 網站 icon
   *
   * PS  因為修改的是 index.html 頁面的icon . 所以需要每個頁面都做一次修改
   *
   */
  selfSetIcon() {
    return;
    var links = document.getElementsByTagName("link"); // 獲取所有 link 元素
    var url = localStorage.brandMemberInfoIcon; // 接口訪問到的
    if (this.ISNULL(url)) {
      url = "";
    }
    for (var i = 0; i < links.length; i++) {
      //遍歷 link 元素
      var link = links[i];
      var rel = link.rel; // rel 表示 link 的類型  icon 對應 shortcut icon
      rel = rel.toLowerCase(); // 部分網站 會 大寫. 統一轉成小寫
      if (rel.indexOf("shortcut icon") > -1) {
        // 當連接中存在 shortcut icon 字眼
        link.href = url; // 修改 網站icon
        break;
      }
    }
  },
  /**
   * 校验文字中是否存在表情  存在 return true
   */
  isEmojiCharacterIndex(substring) {
    if (substring) {
      var flag = false;
      var index = -1;
      for (var i = 0; i < substring.length; i++) {
        var hs = substring.charCodeAt(i);
        if (0xd800 <= hs && hs <= 0xdbff) {
          if (substring.length > 1) {
            var ls = substring.charCodeAt(i + 1);
            var uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000;
            if (0x1d000 <= uc && uc <= 0x1f77f) {
              flag = true;
              index = i;
              break;
            }
          }
        } else if (substring.length > 1) {
          var ls = substring.charCodeAt(i + 1);
          if (ls == 0x20e3) {
            flag = true;
            index = i;
            break;
          }
        } else {
          if (0x2100 <= hs && hs <= 0x27ff) {
            flag = true;
            index = i;
            break;
          } else if (0x2b05 <= hs && hs <= 0x2b07) {
            flag = true;
            index = i;
            break;
          } else if (0x2934 <= hs && hs <= 0x2935) {
            flag = true;
            index = i;
            break;
          } else if (0x3297 <= hs && hs <= 0x3299) {
            flag = true;
            index = i;
            break;
          } else if (
            hs == 0xa9 ||
            hs == 0xae ||
            hs == 0x303d ||
            hs == 0x3030 ||
            hs == 0x2b55 ||
            hs == 0x2b1c ||
            hs == 0x2b1b ||
            hs == 0x2b50
          ) {
            flag = true;
            index = i;
            break;
          }
        }
      }
      return index;
    }
  },
  /**
   * 根据index 截取对应表情
   */
  subToIndex(index, str) {
    var res = str.substring(0, index);
    res += str.substring(index + 2, str.length);
    return res;
  },
  /**
   * 外部调用
   */
  isEmojiCharacter(str) {
    var self = this;
    var str_ = str;
    var flag = false;
    var msg = {};
    var regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
    if (regStr.test(str_)) {
      str_ = str_.replace(regStr, "");
      msg.data = str_;
      msg.res = true;
      return msg;
    }
    // 利用死循环 将每一个表情剔除
    for (var i = 0; i < 1 + i; i++) {
      var index = self.isEmojiCharacterIndex(str_);
      if (index > -1) {
        flag = true;
        str_ = self.subToIndex(index, str_);
      } else {
        break;
      }
    }
    msg.data = str_;
    msg.res = flag;
    return msg;
  },
  /**
   * 生成 頁面參數
   * @param {*} t
   */
  setQueryParams(t) {
    // return Base64.ba_encode(t);
    return this.BASE_.enc(t);
  },
  /**
   * 獲取當前頁 的 參數
   * @param {element} params 參數
   */
  getQueryParams(params, s) {
    let arg = params.arg;
    if (arg) {
      return this.BASE_.dec(arg);
    } else {
      if (s == 1) {
        return [];
      } else {
        // 提示
        Toast({
          duration: 2000,
          message: "此鏈接出現損傷,請重新複製後打開!", // lang_.t("Identity expired"),
          onClose: () => {
            // t.$router.replace({
            //   path: "/"
            // });
          }
        });
      }
    }
  },
  /**
   * 將 內容轉為字符串, 判斷是否為空
   * @param {*} obj
   */
  isNull(obj) {
    obj = obj + "";
    if (
      obj == null ||
      obj == undefined ||
      obj == "" ||
      obj == "NaN" ||
      obj == "undefined" ||
      obj == "null"
    ) {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 判斷是否為空, 並返回值
   * @param {*} obj
   * @param {*} t
   */
  ifNull(obj, t) {
    if (this.isNull(obj)) {
      return t;
    }
    return obj;
  },
  /**
   * 加解密
   * 加密後會出現 =, 將= 替換成 Rp8 意思是 ricepon82002022 的縮寫.
   */
  BASE_: {
    // 解密
    dec(str) {
      try {
        let r = window.atob(str.replace(/Rp8/g, "="));
        let arg = [];
        arg = r.split("_");
        return arg; //把base64解码
      } catch (error) {
        this.$router.push({
          name: "error"
        });
      }
    },
    // 加密
    enc(obj) {
      let k = "";
      if (typeof obj === "object") k = obj.join("_");
      else k = obj;
      let enc_ = window.btoa(k);
      return enc_.replace(/=/g, "Rp8");
    }
  },
  /**
   * 判斷是否是pc
   * @returns {boolean}
   * @constructor
   */
  IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = [
      "Android",
      "iPhone",
      "SymbianOS",
      "Windows Phone",
      "iPad",
      "iPod"
    ];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
  },
  /**
   * 查詢品牌信息
   * @param e
   * @param fun
   */
  getBrand(e, fun) {
    // if (e.riceponBrandId) {
    //   if (typeof fun == "function") {
    //     fun();
    //   }
    //   return;
    // }
    let params = {};
    let brandId = this.getBrandId(e, 1);
    if (brandId) {
      params = {
        brandId: brandId
      };
    } else {
      let brandAlias = "";
      if (
        location.origin.indexOf("192.168") > -1 ||
        location.origin.indexOf("localhost") > -1
      ) {
        brandAlias = "gingersoft-alias";
      } else {
        brandAlias = location.pathname.split("/")[1];
      }
      params = {
        brandAlias: brandAlias
      };
    }
    getBrandByAlias(params).then(res => {
      if (res.success) {
        let data = res.data;
        if (data) {
          let brandConfig = data.brandConfig;
          let brandImgUrl = data.brandImgUrl;
          let brandLogo = data.brandLogoUrl;
          let memberBackgroundUrl = data.memberBackgroundUrl;
          localStorage.setItem("invitation_code", data.invitationCode || 0);
          let color_ = "#006834";
          if (brandConfig) {
            color_ = `rgb(${JSON.parse(brandConfig).brandThemeColor})`;
          }
          // 設置主題色
          let style_ = document.createElement("style");
          style_.type = "text/css";
          Vue.prototype.themeLogo = brandLogo;
          Vue.prototype.themeImg = brandImgUrl;
          Vue.prototype.themeColor = color_;
          Vue.prototype.riceponBrandId = data.id;
          Vue.prototype.memberBackgroundUrl = memberBackgroundUrl;
          document.title = data.brandName;
          let css_ = `
        .self_bg_color{background-color:${color_} !important;border-color:${color_} !important;}
        .van-dialog__header ,.self_color{color:${color_} !important;}
        .self-active{color:${color_} !important;}
        .canClick{background-color:${color_} !important;}

        .self-active::after{background-color:${color_} !important;}
        #app .van-nav-bar__text{color:${color_} !important;}
        .van-tabs__line{background-color:${color_} !important;}
        .self_booking_sel{background-color:${color_} !important;}
      `;
          style_.textContent = css_;
          document.head.append(style_);
          if (document.querySelector(".self-logo")) {
            document.querySelector(".self-logo").src = brandLogo;
          }
          // 設置背景圖
          if (data.brandTicketBg) {
            document.body.setAttribute(
              "style",
              `background-image:url(${data.brandTicketBg})`
            );
          }
        } else {
          // e.$toast({
          //   duration: 2000,
          //   // icon: 'cross',
          //   message: "沒有配置品牌信息,請稍後重試!"
          // });
        }
        if (typeof fun == "function") {
          fun();
        }
      }
    });
  },
  /**
   * 獲取 window 寬高
   */
  getWindowInner() {
    let J = {};
    let w = window.innerWidth;
    let h = window.innerHeight;
    if (this.IsPC()) {
      let h_ = h - 50,
        w_ = h_ / 2.17;
      if (h < 900) {
        w_ = h_ / 1.5;
      }
      J.w = w_ - 20;
      J.h = h_ - 110; // 應該是 657 , 這裡和 app.vue 中的一致, 但是多了個 頂部img , 高度是20 , 所以這裡減掉
      J.w_ = w_;
      J.h_ = h_;
      // if (h < 665) {
      //   J.h = h - 30;
      // }
    } else {
      J.w = w;
      J.h = h;
    }

    return J;
  },
  /**
   * 倒計時
   * 傳入秒數 返回 00:00:00 格式
   */
  // countDown(timeSeconds){
  //   let hours = Math.floor(timeSeconds/(60*60)%24);
  //   let min = Math.floor(timeSeconds/(60)%60);
  //   let seconds = Math.floor(timeSeconds%60);
  //   //小於10 前面補0
  //   hours = hours < 10 ? '0'+hours : hours;
  //   min = min < 10 ? '0'+min : min;
  //   seconds = seconds < 10 ? '0'+seconds : seconds;
  //   //返回結果
  //   return `${hours}:${min}:${seconds}`;
  // }

  // 设置区域号
  setArea() {
    let countryStr = localStorage.getItem("countryLocal");
    if (countryStr) {
      Vue.prototype.country = JSON.parse(country);
    }
    // 查詢 城市
    getCountry()
      .then(res => {
        if (res.success) {
          let country = res.data;
          if (country) {
            Vue.prototype.country = country;
            localStorage.setItem("countryStr", JSON.stringify(country));
          }
        }
      })
      .catch(err => {});
  },
  /**
   * 獲取 樣式
   * @param {元素節點} ele
   * @param {具體屬性} style
   * @returns
   */
  getStyle(ele, style) {
    try {
      let p = ele.style[style];
      if (!p) p = getComputedStyle(ele)[style];
      return p;
    } catch (error) {
      console.log(error);
      return "";
    }
  }
};
export default myfn;



// WEBPACK FOOTER //
// ./src/js/util.js